import React from 'react';
import Html from 'react-pdf-html';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 11,
        marginTop: '-12px',
        fontWeight:'bold'
    },
    container:{
        padding:'3px',
        flexDirection: 'row',
        border:'1px #DDD solid',
        borderRadius:'5px',
        fontWeight:'normal',
        minHeight:'150px'
    },
    text:{
        fontSize: 10,
        whiteSpace: 'pre-line',
    }
  });


  const OrderServiceDescription = ({data}) => (
    <>
        <Text style={styles.reportTitle}>INFORMAÇÕES ADICIONAIS</Text>
        <View style={styles.container}>
            <Text><Html style={styles.text}>{
                (typeof data?.additionalInfo !== 'undefined' && data?.additionalInfo !== null) 
                    ? data?.additionalInfo.split('\n').join("<br/>")
                    : ''
                }</Html></Text>
        </View>
    </>
  );
  
  export default OrderServiceDescription